import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Ripple } from "primereact/ripple";
import { Dialog } from 'primereact/dialog';
import { confirmDialog } from "primereact/confirmdialog";
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from "primereact/checkbox";
import { Image } from "primereact/image";
import { format } from "date-fns";
import DocumentUploadModal from "../DocumentUploadModal";
import DocumentViewModal from "../../../../Components/DocumentViewModal";
import NoDataCreated from "../../../../Components/NoDataCreated";
import TextInput from "../../../../Components/TextInput";
import ErrorPage from "../../../../Components/ErrorPage";
import PageLoader from "../../../../Components/PageLoader";
import { goToTop } from "../../../../Components/goToTop";
import { useAppDispatch, useAppSelector } from "../../../../Controllers/hooks";
import { fetchSubFoldersAndDocuments, setCheckedSubFolderContactForAssign, setSubFolderAllContact, setSubFolderAssignedContact } from "../../../../Controllers/Slices/projectDetailsSlice";
import { SubFolderAndDocument } from "../../../../Controllers/Types/Project/Service/SubFolderInterface";
import { deleteSubFolder, subFolderCreateAPI, subFolderShareContact, subFolderUpdateAPI } from "../../../../Api/Project/SubFolderApi";
import { checkFileOthers, checkText } from "../../../../Utils/Validator";
import { baseURL } from "../../../../Api/ApiConstant";
import { ProjectBasicContact } from "../../../../Controllers/Types/Project/ProjectInterface";
import { ShareContact } from "../../../../Controllers/Types/Project/ShareContactInterface";
import { serviceTypeDocumentCreateAPI, serviceTypeDocumentDeleteAPI, serviceTypeDocumentUpdateAPI } from "../../../../Api/Project/ServiceTypeDocument";
import TableActionLoader from "../../../../Components/TableActionLoader";

const Drawing: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const projectData = location.state?.data;
    const serviceId = projectData.folder_id;
    const folderType = projectData.folder_type;
    const dispatch = useAppDispatch()
    const loadingDocument = useAppSelector((state) => state.projectDetails.loading);
    const errorDocument = useAppSelector((state) => state.projectDetails.error);
    const loadingSubFolderAndDocument = useAppSelector((state) => state.projectDetails.loadingSubFolderAndDocument)
    const errorSubFolderAndDocument = useAppSelector((state) => state.projectDetails.errorSubFolderAndDocument)
    const subFolderAndDocumentList = useAppSelector((state) => state.projectDetails.subFolderAndDocumentList)
    const subFolderAssignedContact = useAppSelector((state) => state.projectDetails.subFolderAssignedContact)
    const isShared: boolean = projectData.sharedBy !== null ? true : false;

    const [filteredDrawingData, setFilteredDrawingData] = useState<SubFolderAndDocument[]>([]);

    const toast = useRef<Toast>(null);
    // const loadingPage = useAppSelector((state) => state.project.loading)
    // const error = useAppSelector((state) => state.project.error)

    const [loading, setLoading] = useState<boolean>(false);
    const [showDocumentViewModal, setShowDocumentViewModal] = useState(false);
    const [dataState, setDataState] = useState<'Add' | 'Edit'>('Add');

    /* ******************************** For sub folder ******************************** */
    const [showSubFolderModal, setShowSubFolderModal] = useState(false);
    const [subFolderName, setSubFolderName] = useState<string>('');
    const [subFolderNameError, setSubFolderNameError] = useState<string>('');
    /* ********************************************************************************* */


    /* ****************************** For assign contact ****************************** */
    const [showAssignModal, setShowAssignModal] = useState(false);
    const [checkedContact, setCheckedContact] = useState<boolean>(false);
    /* ********************************************************************************* */


    /* ****************************** For File upload ****************************** */
    const [isFileModalOpen, setIsFileModalOpen] = useState(false);
    const [documentPath, setDocumentPath] = useState<string>('');
    const [documentName, setDocumentName] = useState<string>('');
    const [uploadedFileName, setUploadedFileName] = useState<string>('');
    const [uploadedFile, setUploadedFile] = useState<File | null>(null);

    const [documentNameError, setDocumentNameError] = useState<string>('');
    const [uploadedFileError, setUploadedFileError] = useState<string>('');

    const [isFileRequired, setIsFileRequired] = useState(false);
    const [userType, setUserType] = useState<'Employee' | 'Professional' | 'Client' | null>(null);
    const [documentUpdateHasChanges, setDocumentUpdateHasChanges] = useState<boolean>(false);
    const [subFolderUpdateHasChanges, setSubFolderUpdateHasChanges] = useState<boolean>(false);
    const [selectedDocument, setSelectedDocument] = useState<SubFolderAndDocument | null>(null);
    const [selectedSubFolder, setSelectedSubFolder] = useState<SubFolderAndDocument | null>(null);

    const [drawingViewState, setDrawingViewState] = useState<'Sub folder' | 'Document'>('Sub folder');
    const [deleteLoadingId, setdeleteLoadingId] = useState<number | null>(null);

    const handleOpenUploadFileModal = () => {
        setDataState('Add');
        setIsFileModalOpen(true);
        setIsFileRequired(true);
    };

    const handleClearFile = () => {
        setUploadedFileName('');
        setUploadedFile(null);
    };

    useEffect(() => {
        if (subFolderAndDocumentList && subFolderAndDocumentList?.length > 0) {
            let filterdData: SubFolderAndDocument[] = [];

            if (drawingViewState === 'Sub folder') {
                filterdData = subFolderAndDocumentList?.filter(drawing => drawing?.category === 'sub_folder');
            } else if (drawingViewState === 'Document') {
                filterdData = subFolderAndDocumentList?.filter(drawing => drawing?.category === 'document');
            } else {
                filterdData = [];
            }

            setFilteredDrawingData(filterdData);
        } else {
            setFilteredDrawingData([]);
        }
    }, [drawingViewState, subFolderAndDocumentList]);

    const handleChangeDrawingViewState = (state: 'Sub folder' | 'Document') => {
        setDrawingViewState(state);
    }

    useEffect(() => {
        if (selectedDocument) {
            if (documentName !== selectedDocument?.title) {
                setDocumentUpdateHasChanges(true);
            } else if (uploadedFile !== null) {
                setDocumentUpdateHasChanges(true);
            } else {
                setDocumentUpdateHasChanges(false);
            }
        }
    }, [selectedDocument, documentName, uploadedFile]);

    const handleOpenEditFileModal = (subAndDoc: SubFolderAndDocument) => {
        setDataState('Edit');
        setIsFileModalOpen(true);
        setSelectedDocument(subAndDoc);
        setDocumentName(subAndDoc.title)
    };

    const handleCloseFileModal = () => {
        setIsFileModalOpen(false);
        handleClearDocumentFields();
        handleClearDocumentErrors();
    };

    const handleFileUpload = (file: File) => {
        setUploadedFileName(file.name);
        setUploadedFile(file);
    };

    useEffect(() => {
        checkText(documentName, false, setDocumentNameError);
    }, [documentName]);

    useEffect(() => {
        checkFileOthers(uploadedFile!, false, setUploadedFileError);
    }, [uploadedFile]);

    function checkCredentialsUploadFile(isRequiredFile: boolean): boolean {
        const isServiceNameValid = checkText(documentName, true, setDocumentNameError);
        const isUploadedFileValid = checkFileOthers(uploadedFile!, isRequiredFile, setUploadedFileError);

        return isServiceNameValid && isUploadedFileValid;
    }

    const handleClearDocumentFields = () => {
        setDocumentName('')
        setUploadedFile(null)
        setUploadedFileName('');

        setIsFileRequired(false);
        setSelectedDocument(null);
    }

    const handleClearDocumentErrors = () => {
        setDocumentNameError('')
        setUploadedFileError('')
    }

    const handleUploadFile = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsUploadFile(isFileRequired)) {
            setLoading(true);
            const data = await serviceTypeDocumentCreateAPI(Number(projectData.project_id), Number(serviceId), documentName, uploadedFile!);
            setLoading(false);

            if (data.statusCode === 200) {
                dispatch(fetchSubFoldersAndDocuments(Number(serviceId)))

                handleCloseFileModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Document added successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error uploading document.',
                        detail: 'There was an error uploading document.',
                        life: 3000
                    });
                }
            }
        }
    };

    const handleUpdateFile = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentialsUploadFile(isFileRequired)) {
            setLoading(true);
            const data = await serviceTypeDocumentUpdateAPI(selectedDocument?.id!, documentName, uploadedFile!);
            setLoading(false);

            if (data.statusCode === 200) {
                dispatch(fetchSubFoldersAndDocuments(Number(serviceId)))

                handleCloseFileModal();
                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Document updated successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Error uploading document.',
                        detail: 'There was an error uploading document.',
                        life: 3000
                    });
                }
            }
        }
    };

    const handleDeleteFile = async (fileId: number) => {
        confirmDialog({
            message: `Are you sure you want to delete the file detail?`,
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteFileData(),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // delete operation
    const deleteFileData = async () => {
        if (checkCredentialsUploadFile(isFileRequired)) {
            const data = await serviceTypeDocumentDeleteAPI(selectedDocument?.id!);

            if (data.statusCode === 200) {
                dispatch(fetchSubFoldersAndDocuments(Number(serviceId)))

                handleCloseFileModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Document deleted successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Document deleted failed',
                        detail: 'There was an error deleting document.',
                        life: 3000
                    });
                }
            }
        }
    }
    /* ********************************************************************************* */


    /* ******************************** For sub Folder ******************************** */
    const handleOpenSubFolderCreateModal = () => {
        setDataState('Add');
        setShowSubFolderModal(true);
    };

    const handleOpenSubFolderEditModal = (subFolder: SubFolderAndDocument) => {
        setDataState('Edit');
        setShowSubFolderModal(true);
        setSelectedSubFolder(subFolder);
        setSubFolderName(subFolder?.title);
    };

    const handleClearSubFolderFields = () => {
        setSubFolderName('');
        setSelectedSubFolder(null);
    }

    const handleClearSubFolderErrors = () => {
        setSubFolderNameError('');
    }

    useEffect(() => {
        checkText(subFolderName, false, setSubFolderNameError);
    }, [subFolderName]);

    function checkCredentials(): boolean {
        const isServiceNameValid = checkText(subFolderName, true, setSubFolderNameError);

        return isServiceNameValid;
    }

    const handleCloseSubFolderModal = () => {
        setShowSubFolderModal(false);
        handleClearSubFolderFields();
        handleClearSubFolderErrors();
    }

    const handleCreateSubFolder = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const res = await subFolderCreateAPI(projectData.project_id, projectData.folder_id, subFolderName);
            setLoading(false);

            if (res.status) {
                dispatch(fetchSubFoldersAndDocuments(Number(projectData.folder_id)));
                handleCloseSubFolderModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Sub folder created successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Sub folder created failed.',
                        life: 3000
                    });
                }
            }
        }
    }

    useEffect(() => {
        if (selectedSubFolder) {
            if (subFolderName !== selectedSubFolder?.title) {
                setSubFolderUpdateHasChanges(true);
            } else {
                setSubFolderUpdateHasChanges(false);
            }
        }
    }, [selectedSubFolder, subFolderName])

    const handleUpdateSubFolder = async (e: React.FormEvent) => {
        e.preventDefault();

        if (checkCredentials()) {
            setLoading(true);
            const res = await subFolderUpdateAPI(selectedSubFolder?.id!, subFolderName);
            setLoading(false);

            if (res.status) {
                dispatch(fetchSubFoldersAndDocuments(Number(projectData.folder_id)));
                handleCloseSubFolderModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Sub folder updated successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Sub folder updated failed.',
                        life: 3000
                    });
                }
            }
        }
    }

    const handleDeleteSubFolder = async () => {
        confirmDialog({
            message: `Are you sure you want to delete the ${selectedSubFolder?.title} folder?`,
            header: 'Confirm the deletion',
            icon: 'bi bi-info-circle',
            defaultFocus: 'accept',
            acceptClassName: 'p-button-danger',
            accept: () => deleteSubFolderData(),
            resizable: false,
            draggable: false,
            dismissableMask: true,
        });
    }

    // delete operation
    const deleteSubFolderData = async () => {
        setdeleteLoadingId(selectedSubFolder?.id!);
        const res = await deleteSubFolder(selectedSubFolder?.id!);

        setdeleteLoadingId(null);
        if (res.status) {
            dispatch(fetchSubFoldersAndDocuments(Number(projectData.folder_id)))
            handleCloseSubFolderModal();

            if (toast.current) {
                toast.current?.show({
                    severity: "success",
                    summary: "Success",
                    detail: `Sub folder deleted successfully.`,
                    life: 3000,
                });
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'Sub folder deleted failed.',
                    life: 3000
                });
            }
        }
    }


    /* Modal header */
    const subFolderModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                {dataState === 'Add' ? 'Add ' : 'Edit '} sub folder name
            </h5>

            {dataState === 'Edit' ? (
                <React.Fragment>
                    {deleteLoadingId === selectedSubFolder?.id ? (
                        <TableActionLoader className="is_modal_loader" />
                    ) : (
                        <button type="button" className="close_modal_btn p-ripple"
                            onClick={() => handleDeleteSubFolder()}>
                            <i className="bi bi-trash3"></i>
                            <Ripple />
                        </button>
                    )}
                </React.Fragment>
            ) : (
                <button type="button" className="close_modal_btn p-ripple"
                    onClick={handleCloseSubFolderModal}>
                    <i className="bi bi-x-circle"></i>
                    <Ripple />
                </button>
            )}
        </div>
    );

    /* Modal footer */
    const subFolderModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseSubFolderModal}
            />

            <Button
                label={`${loading ? 'Processing' : dataState === 'Add' ? 'Save' : 'Update'}`}
                onClick={dataState === 'Add' ? handleCreateSubFolder : handleUpdateSubFolder}
                loading={loading}
                className="custom_btn primary"
                disabled={dataState === 'Edit' && !subFolderUpdateHasChanges}
            />
        </div>
    );
    /* ********************************************************************************* */


    /* ****************************** For show folder data ***************************** */
    useEffect(() => {
        dispatch(fetchSubFoldersAndDocuments(Number(serviceId)));
        dispatch(setSubFolderAllContact(projectData.serviceAssignedContact));
    }, [])

    /* ********************************************************************************* */

    /* ****************************** For assign contacta ****************************** */
    const handleOpenAssignModal = (subFolder: SubFolderAndDocument) => {
        setShowAssignModal(true);
        setSelectedSubFolder(subFolder);
        dispatch(setSubFolderAssignedContact(subFolder.assign))
    }

    const handleCloseAssignModal = () => {
        setShowAssignModal(false);
        setSelectedSubFolder(null);
    };

    const handleCheckForAssignContact = (contact: ProjectBasicContact) => {
        dispatch(setCheckedSubFolderContactForAssign(contact))
    }

    const handleAssignContact = async (e: React.FormEvent) => {
        e.preventDefault();
        const share: ShareContact[] = [];

        subFolderAssignedContact.forEach((contact) => {
            if (contact.icChecked) {
                const shareCon: ShareContact = {
                    by: contact.by,
                    id: contact.id
                }
                share.push(shareCon)
            }
        })

        if (share.length > 0) {
            setLoading(true);
            const res = await subFolderShareContact(selectedSubFolder?.id!, share);
            setLoading(false);

            if (res.status) {
                dispatch(fetchSubFoldersAndDocuments(Number(serviceId)))
                handleCloseAssignModal();

                if (toast.current) {
                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: `Contact(s) assigned successfully.`,
                        life: 3000,
                    });
                }
            } else {
                if (toast.current) {
                    toast.current.show({
                        severity: 'error',
                        summary: 'Failed',
                        detail: 'Contact(s) assigned failed.',
                        life: 3000
                    });
                }
            }
        } else {
            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'Please select at least one contact from the list.',
                    life: 3000
                });
            }
        }
    }

    /* Modal header */
    const assignContactModalHeader = (
        <div className="custom_modal_header_inner">
            <h5 className="modal-title fs-5">
                Assign folder
            </h5>
            <button type="button" className="close_modal_btn p-ripple"
                onClick={handleCloseAssignModal}>
                <i className="bi bi-x-circle"></i>
                <Ripple />
            </button>
        </div>
    );

    /* Modal footer */
    const assignContactModalFooter = (
        <div className="custom_modal_footer">
            <Button
                label="Close"
                className="custom_btn secondary"
                onClick={handleCloseAssignModal}
            />

            <Button
                label={`${loading ? 'Assigning' : 'Assign'}`}
                loading={loading}
                onClick={handleAssignContact}
                className="custom_btn primary"
                disabled={subFolderAssignedContact?.length === 0}
            />
        </div>
    );
    /* ********************************************************************************* */


    /* ******************************* For view document ******************************* */
    const handleOpenDocumentViewModal = (path: string) => {
        setDocumentPath(path);
        setShowDocumentViewModal(true);
    };

    const goToView = (data: SubFolderAndDocument) => {
        const category = data.category;
        const filePath = baseURL + data.path;
        const dafaultFolder = data.is_default_folder;

        if (category === 'sub_folder') {
            const itemData = { project_id: projectData?.project_id, job_number: projectData?.job_number, address: projectData?.address, folder: projectData.folder, service_name: projectData.service_name, sub_folder_name: data.title, subFolderId: data.id, folder_type: folderType, sharedBy: projectData.sharedBy };
            if (dafaultFolder === 1) {
                navigate(`/project/detail/custom-service/drawing/default-folder`, { state: { data: itemData } });
            } else {
                navigate(`/project/detail/custom-service/drawing/sub-folder`, { state: { data: itemData } });
            }
        } else if (category === 'document') {
            handleOpenDocumentViewModal(filePath);
        }
    }

    const handleCloseDocumentViewModal = () => {
        setShowDocumentViewModal(false);
    };


    const assignContactBody = (rowData: SubFolderAndDocument) => {
        const assignContacts = rowData.assignedContact;
        return (
            <React.Fragment>
                {assignContacts?.length > 0 ? (
                    <div className="project_card_contact_area p-0 mt-1 mb-1 no_pointing">
                        {assignContacts.slice(0, 3).map((contact) => (
                            <div key={contact.id} className="project_card_contact">
                                {contact.first_name ? contact.first_name[0] : ''}{contact.last_name ? contact.last_name[0] : ''}
                            </div>
                        ))}

                        {assignContacts.length > 3 && (
                            <h6 className="project_card_contact_has_more">
                                +{assignContacts.length - 3}
                            </h6>
                        )}
                    </div>
                ) : (
                    <span className="text-secondary">
                        -----
                    </span>
                )}
            </React.Fragment>
        )
    }

    const noOfDocBody = (rowData: SubFolderAndDocument) => {
        return (
            <span className="text-center text-secondary d-flex justify-content-center">
                {rowData.count}&nbsp;File{rowData?.count > 1 ? 's' : ''}
            </span>
        )
    }

    const tableActionBody = (rowData: SubFolderAndDocument) => {
        const category = rowData.category;

        return (
            <div className="table_action_btn_area justify-content-end">
                <button className="table_action_btn p-ripple"
                    onClick={() => goToView(rowData)}>
                    View
                    <Ripple />
                </button>

                {!isShared && (
                    <React.Fragment>
                        {/* {drawingViewState === 'Sub folder' && (
                            <button className="table_action_btn p-ripple"
                                disabled={category === 'document'}
                                onClick={() => handleOpenAssignModal(rowData)}>
                                Assign
                                <Ripple />
                            </button>
                        )} */}

                        <button className="table_action_btn p-ripple"
                            disabled={rowData.is_default_folder === 1}
                            onClick={() => category === 'sub_folder' ? handleOpenSubFolderEditModal(rowData) : handleOpenEditFileModal(rowData)}>
                            Edit
                            <Ripple />
                        </button>
                    </React.Fragment>
                )}
            </div>
        )
    }
    /* ********************************************************************************* */

    const handleSelectUserType = (type: 'Employee' | 'Professional' | 'Client' | null) => {
        setUserType(type);
    }

    const goBack = () => {
        navigate(-1);
        goToTop();
    };

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <div className="main_content layout_padding show_side_bar">
                {(loadingSubFolderAndDocument || loadingDocument) ? (
                    <PageLoader />
                ) : (errorSubFolderAndDocument || errorDocument) ? (
                    <ErrorPage errorMessage={errorSubFolderAndDocument! || errorDocument!} />
                ) : (
                    <div className="page_content mt-0">
                        <div className="page_breadcrumb_area">
                            <ul className="page_breadcrumb">
                                <li className="page_breadcrumb_item has_child has_link" onClick={() => navigate(-1)}>
                                    {projectData.job_number} : {projectData.address}
                                </li>
                                <li className="page_breadcrumb_item has_child">
                                    {projectData.folder}
                                </li>
                                <li className="page_breadcrumb_item active">
                                    {projectData.service_name}
                                </li>
                            </ul>

                            <button className="back_btn p-ripple" onClick={goBack}>
                                <i className="bi bi-arrow-left me-2"></i>
                                Back
                                <Ripple />
                            </button>
                        </div>

                        <div className="page_header_area mt-3">
                            <div className="contact_tabs">
                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width ${drawingViewState === 'Sub folder' ? "active" : ""} p-ripple`}
                                        onClick={() => handleChangeDrawingViewState('Sub folder')}
                                    >
                                        Sub folder
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>

                                <div className="contact_tab_item">
                                    <button
                                        type="button"
                                        className={`contact_tab_btn fixed_min_width ${drawingViewState === 'Document' ? "active" : ""} p-ripple`}
                                        onClick={() => handleChangeDrawingViewState('Document')}
                                    >
                                        Document
                                        <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                    </button>
                                </div>
                            </div>

                            <div className="page_action_area gap-2">
                                {!isShared && (
                                    <React.Fragment>
                                        {drawingViewState === 'Document' ? (
                                            <button className="add_data_link_btn p-ripple" onClick={handleOpenUploadFileModal}>
                                                <i className="bi bi-arrow-up-circle"></i>
                                                <span>Upload file</span>
                                                <Ripple />
                                            </button>
                                        ) : (
                                            <button className="add_data_link_btn p-ripple" onClick={handleOpenSubFolderCreateModal}>
                                                <i className="bi bi-plus-circle"></i>
                                                <span>Add sub folder</span>
                                                <Ripple />
                                            </button>
                                        )}
                                    </React.Fragment>
                                )}
                            </div>
                        </div>

                        <div className="page_main_content_section">
                            {subFolderAndDocumentList?.length > 0 ? (
                                <DataTable
                                    value={filteredDrawingData}
                                    paginator
                                    size="small"
                                    rows={10}
                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                    tableStyle={{ minWidth: '50rem' }}
                                    paginatorDropdownAppendTo={'self'}
                                    paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                                    currentPageReportTemplate="{first} to {last} of {totalRecords}"
                                    className="page_table p-0 p-sm-2"
                                    rowHover
                                    loading={loadingSubFolderAndDocument || loadingDocument}
                                    scrollable
                                    emptyMessage={drawingViewState === 'Document' ? 'No document has been uploaded.' : 'No folders were created.'}
                                >
                                    <Column
                                        header="Document"
                                        headerClassName="text_purple"
                                        field="title"
                                        body={(rowData: SubFolderAndDocument) => (
                                            <span>
                                                {rowData?.title ? rowData?.title : '---'}
                                            </span>
                                        )}
                                        style={{ width: '25%' }}
                                    ></Column>

                                    {drawingViewState === 'Sub folder' ? [
                                        <Column
                                            header="Project contact"
                                            headerClassName="text_purple"
                                            body={assignContactBody}
                                            style={{ width: '25%' }}
                                        ></Column>,

                                        <Column
                                            header="No. of doc"
                                            headerClassName="text_purple"
                                            alignHeader={'center'}
                                            body={noOfDocBody}
                                            style={{ width: '15%' }}
                                        ></Column>,
                                    ] : [
                                        <Column
                                            header="Uploaded date/time"
                                            headerClassName="text_purple"
                                            field="update_at"
                                            body={(rowData: SubFolderAndDocument) => (
                                                <span className="text_no_wrap">
                                                    {rowData?.created_datatime
                                                        ? format(
                                                            new Date(rowData.created_datatime),
                                                            "yyyy-MM-dd | hh:mm a"
                                                        )
                                                        : "---"}
                                                </span>
                                            )}
                                            style={{ width: "20%" }}
                                        ></Column>
                                    ]}

                                    <Column
                                        body={tableActionBody}
                                        className="table_btn_area"
                                        style={{ width: '35%' }}
                                        frozen={window.innerWidth > 575}
                                        alignFrozen="right"
                                    ></Column>
                                </DataTable>
                            ) : (
                                <NoDataCreated
                                    message={`No ${projectData.service_name} files or folders added. ${!isShared ? 'To add the file click on upload button or add the folder click on add button' : ''}`}
                                />
                            )}
                        </div>
                    </div>
                )}

                {/* Document upload modal */}
                <DocumentUploadModal
                    isOpen={isFileModalOpen}
                    dataState={dataState}
                    onClose={handleCloseFileModal}
                    toast={toast}
                    documentName={documentName}
                    setDocumentName={setDocumentName}
                    uploadedFileName={uploadedFileName}
                    handleFileUpload={handleFileUpload}
                    handleCreateDocument={handleUploadFile}
                    handleUpdateDocument={handleUpdateFile}
                    handleDeleteDocument={() => handleDeleteFile(selectedDocument?.id!)}
                    hasDelete={true}
                    loading={loading}
                    documentNameError={documentNameError}
                    fileError={uploadedFileError}
                    labelName="Title"
                    headerName="file"
                    isFileRequired={dataState === 'Add' ? true : false}
                    isFileNameRequired={true}
                    handleClearFile={handleClearFile}
                    documentUpdateHasChanges={documentUpdateHasChanges}
                />
                {/*  */}

                {/* Document view modal */}
                <DocumentViewModal
                    isOpen={showDocumentViewModal}
                    onClose={handleCloseDocumentViewModal}
                    fileUrl={documentPath}
                />
                {/*  */}

                {/* Sub folder modal */}
                <Dialog
                    visible={showSubFolderModal}
                    header={subFolderModalHeader}
                    footer={subFolderModalFooter}
                    headerClassName="custom_modal_header"
                    className="custom_modal_dialog modal_dialog_sm"
                    onHide={handleCloseSubFolderModal}
                    dismissableMask
                >
                    <div className="custom_modal_body">
                        <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
                            <div className="row">
                                <div className="col-12">
                                    <TextInput
                                        id="subFolderName"
                                        label="Sub folder name"
                                        labelHtmlFor="subFolderName"
                                        required={true}
                                        value={subFolderName}
                                        placeholder="Sub folder name"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSubFolderName(e.target.value)}
                                        error={subFolderNameError}
                                        formGroupClassName="mb-2"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </Dialog>
                {/*  */}

                {/* Contact assign modal */}
                <Dialog
                    visible={showAssignModal}
                    header={assignContactModalHeader}
                    footer={assignContactModalFooter}
                    headerClassName="custom_modal_header"
                    className="custom_modal_dialog modal_dialog_sm assign_contact_modal"
                    onHide={handleCloseAssignModal}
                    dismissableMask
                >
                    <div className="custom_modal_body fixed_height">
                        <div className="pt-0 ps-2 pe-2 pb-2 w-100">
                            <div className="share_contact_tab_header">
                                <div className="contact_tabs">
                                    <div className="contact_tabs">
                                        <div className="contact_tab_item">
                                            <button type="button"
                                                className={`contact_tab_btn ${userType === null ? 'active' : ''} p-ripple`}
                                                onClick={() => (handleSelectUserType(null))}>
                                                All
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>
                                        </div>

                                        <div className="contact_tab_item">
                                            <button type="button"
                                                className={`contact_tab_btn ${userType === 'Employee' ? 'active' : ''} p-ripple`}
                                                onClick={() => (handleSelectUserType('Employee'))}>
                                                Employee
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>
                                        </div>

                                        <div className="contact_tab_item">
                                            <button type="button"
                                                className={`contact_tab_btn ${userType === 'Professional' ? 'active' : ''} p-ripple`}
                                                onClick={() => (handleSelectUserType('Professional'))}>
                                                Professional
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>
                                        </div>

                                        <div className="contact_tab_item">
                                            <button type="button"
                                                className={`contact_tab_btn ${userType === 'Client' ? 'active' : ''} p-ripple`}
                                                onClick={() => (handleSelectUserType('Client'))}>
                                                Client
                                                <Ripple pt={{ root: { style: { background: 'rgba(164, 96, 253, 0.2)' } } }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                {subFolderAssignedContact?.length > 0 ? (
                                    <div className="col-12">
                                        <ul className="assign_contact_list_area">
                                            {subFolderAssignedContact.map((contact) => (
                                                <li className="assign_contact_list">
                                                    <Checkbox onChange={(e) => handleCheckForAssignContact(contact)} checked={contact.icChecked}></Checkbox>

                                                    <button className={`contact_slide_tab assign_contact ${checkedContact ? 'active' : ''}`}
                                                        onClick={() => setCheckedContact(!checkedContact)}>
                                                        <Image className="contact_profile_img" src={`${baseURL}${contact?.profile_image}`} alt="Profile" />
                                                        <div className="contact_slide_det">
                                                            <h6>{contact.first_name}</h6>
                                                            <p>{contact.role_name ? contact.role_name : '---'}</p>
                                                        </div>
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                ) : (
                                    <div className="col-12">
                                        <div className="no_data_found mt-2 mb-2">
                                            <h6>No contacts found!</h6>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </Dialog>
                {/*  */}
            </div>
        </React.Fragment>
    )
}

export default Drawing;